import { IDevModePricingVariables } from "../hooks/usePurchasePlan"

export const mapPricingCalculator = (item: App.Pricings): App.PricingCalculatorItem => ({
  variableNameInExpression: item.variableNameInExpression || "",
  parameter: item.parameter || "",
  scopeType: item.scopeType || "",
  source: item.source || "",
  variableLabelForDisplay: item.variableLabelForDisplay || "",
  min: item.min || "",
  max: item.max || "",
  baseUnit: item.baseUnit || "",
  isVisible: item.isVisible || false,
  isCalculated: item.isCalculated ?? false,
  // If strict, should check for empty keys in the object (empty string or null, empty array) and only if not all empty adds the property to the object
  pricingCalculator: item.pricingCalculator
})

export const mapPricingCalculatorStrict = (item: App.Pricings): App.PricingCalculatorItem => ({
  ...mapPricingCalculator(item),
  // If strict, should check for empty keys in the object (empty string or null, empty array) and only if not all empty adds the property to the object
  pricingCalculator:
    item.isCalculated && !hasAllEmptyValues(item.pricingCalculator) ? item.pricingCalculator : undefined
})

export const mapPricingVariableCalculator = (item: App.Pricings): App.PricingCalculatorVariableItem => ({
  variableNameInExpression: item.variableNameInExpression || "",
  parameter: item.parameter || "",
  scopeType: item.scopeType || "",
  source: item.source || ""
})

export const mapPricingExpression = (item: App.Pricings): App.PricingExpressionItem => ({
  variableNameInExpression: item.variableNameInExpression || "",
  parameter: item.parameter || "",
  scopeType: item.scopeType || "",
  source: item.source || "",
  isQuota: item.isQuota || false,
  canOverflow: (item.isQuota && item.canOverflow) || false,
  quotaSize: item.isQuota === true ? item.quotaSize || "" : "",
  min: item.min || "",
  max: item.max || "",
  variableLabelForDisplay: item.variableLabelForDisplay || ""
})

function hasAllEmptyValues(obj: Record<string, any> | undefined) {
  if (!obj) return true

  return Object.values(obj).every((value) => {
    if (Array.isArray(value)) {
      return value.length === 0
    }

    return value === "" || value === null
  })
}

// summary mappers

export const mapPricingCalculatorDebouncedValues = (
  pricingCalculator?: IDevModePricingVariables
): { scope: App.PricingExpressionSummary[]; strExpression: string } => {
  return {
    strExpression: pricingCalculator?.mathExp ?? "",
    scope: pricingCalculator?.list.map(mapPricingCalculatorStrict).map((e) => ({ ...e, min: e.min || 1 })) ?? []
  }
}

export const filterRelevantCalculatorParams = (scope: App.PricingExpressionSummary[]) => {
  return scope?.map((s) => ({
    baseUnit: s.baseUnit,
    scopeType: s.scopeType,
    source: s.source,
    variableLabelForDisplay: s.variableLabelForDisplay,
    variableNameInExpression: s.variableNameInExpression
  }))
}
